import React from 'react';
import { TextButton } from 'js/design_system/TextButton';
import { Button } from 'js/design_system/Button';
type Props = {
  buttonText: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const ContinueWithEmailButton: React.FC<Props> = (props) => {
  const { onClick, disabled, buttonText, ...buttonProps } = props;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userInChina = (window as any).userInChina === 'true';

  const commonProps = {
    onClick: disabled ? () => {} : onClick,
    disabled,
    children: buttonText,
    ...buttonProps,
  };
  return userInChina ? (
    <Button {...commonProps} />
  ) : (
    <TextButton icon="email" {...commonProps} />
  );
};
